import api from "./api";
const milkEntryService = async (inputs, time, isAutoIncrement, userId = "") => {
  let response;



  try {
    if (userId) {
      // If userId exists, use the admin endpoint
      response = await api.post(`/admin/entries/${time}`, {
        ...inputs,
        userId,
      });
    } else {
      // If userId does not exist, use the standard endpoint
      response = await api.post(`/entries/${time}`, inputs);
    }

    // Validate the response before processing further
    if (response?.status === 200 && response?.data) {
      console.log("this was the status",response.status)
      const updatedInputs = {
        weight: "",
        fat: "",
        snf: "",
        price: "", // Reset the necessary fields
      };

      // Handle auto-increment date logic
      const newDate = isAutoIncrement
        ? (() => {
            const date = new Date(inputs.date);
            date.setDate(date.getDate() + 1);
            return date.toISOString().split("T")[0];
          })()
        : inputs.date;

      return { message: response.data.message, updatedInputs, newDate };
    } else {
      throw new Error("Unexpected response format");
    }
  } catch (error) {
    console.error("Error in milkEntryService:", error);
    throw error;
  }
};

export default milkEntryService;
